var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.menuOption.menu.is_soldout)?_c('p',{staticClass:"OptionStockBox"},[_c('q-translate',{attrs:{"placeholder":"SOLDOUT","text-key":"lang-0143"}})],1):(_vm.menuOption.menu.is_set_maximum_order_per_day)?_c('p',{staticClass:"OptionStockBox"},[_vm._v("残り"+_vm._s(_vm.remain)+"個")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }